import { render, staticRenderFns } from "./selected_dispache.vue?vue&type=template&id=97f672f4"
import script from "./selected_dispache.vue?vue&type=script&lang=ts"
export * from "./selected_dispache.vue?vue&type=script&lang=ts"
import style0 from "./selected_dispache.vue?vue&type=style&index=0&id=97f672f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports